module.exports = __webpack_public_path__ + "static/media/quansh_16x.b28c86bf.svg";